const WOMAuthorizationUrl = process.env.REACT_APP_WOM_API_URL;
const WOMClientId = process.env.REACT_APP_WOM_CLIENT_ID;
const WOMKcIdpHint = process.env.REACT_APP_WOM_KC_IDP_HINT;

const PORTOAuthorizationUrl = process.env.REACT_APP_PORTO_API_URL;
const PORTOClientId = process.env.REACT_APP_PORTO_CLIENT_ID;

export const OAuthCredentials = {
  WOM: {
    authorizationUrl: `${WOMAuthorizationUrl}/auth`,
    tokenUrl: `${WOMAuthorizationUrl}/token`,
    clientId: WOMClientId,
    scope: 'openid profile email roles',
    extraParams: { kc_idp_hint: WOMKcIdpHint },
  },
  PORTO: {
    authorizationUrl: `${PORTOAuthorizationUrl}/auth`,
    tokenUrl: `${PORTOAuthorizationUrl}/token`,
    clientId: PORTOClientId,
    extraParams: { redirect_uri: 'https://front-hml.ultracar.com.br/login' },
  },
};
